import { Injectable } from '@angular/core';
import { Common } from '../model/common.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable()
export class RegistrationService {

  constructor(private http: HttpClient) {
   }

  Register(registerModel) {
    return this.http.post(environment.APIUrl + '/UserModule/InsertNewUser', registerModel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  CheckEmail(email){
    var model={
      email:email,
      company:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/CheckEmailForCustomer', model, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  CHangePassword(type, UserName, Password,custId) {    
    var rmodel={
      type:type,
      UserName:UserName,
      Password:Password,
      custId:custId,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/ChangePassword',rmodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  BusinesstoBusinessRegistration(rmodel){
    return this.http.post(environment.APIUrl + '/UserModule/BusinesstoBusinessRegistration',rmodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  getCountry() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllCountries', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  getRegistrationControls() {
    return this.http.get(environment.APIUrl + '/UserModule/Getregistercontrold', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }


  getState(countryId) {
    var umodel={
      Country:countryId
    }  
      return this.http.post(environment.APIUrl + '/UserModule/GetAllStates',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  getCity(stateId) {
    var smodel={
      stetes:stateId
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetAllCities',smodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  Login(loginModel) {
    loginModel.company_sy=Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/UserModule/Login', loginModel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  Loginship(loginModel) {
    loginModel.company_sy=Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/UserModule/LoginToship', loginModel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  LoginNew(loginModel) {
    loginModel.company_sy=Common.getWithExpiry("company_sy");
    return this.http.post(environment.APIUrl + '/UserModule/LoginNew', loginModel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  GuestLogin() {
    var company_sy=Common.getWithExpiry("company_sy");
    return this.http.get(environment.APIUrl + '/UserModule/GuestLogin?company_sy='+company_sy, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  GetCuUserList(CustID,pageno) {
    var umodel={
      customer:CustID,
      pageno:pageno,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetCuUserList',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  ForgotPasswordForCustomerCuUser(customer,UserID) {
    var umodel={
      customer:customer,
      userId:UserID,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/ForgotPasswordForCustomerCuUser',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  ForgotPasswordForSalesman(UserID) {
    var umodel={
      userId:UserID,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/ForgotPasswordForSalesman',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  GetContactsForProfile(customer) {
    var umodel={
      customer:customer,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/DistOneAPi/GetContactsForProfile',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  GetProfileDetails(customer) {
    var umodel={
      customer:customer,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetProfileDetails',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  GetconfigurationforshowprovinceinRegistration() {
    return this.http.get(environment.APIUrl + '/Product/GetconfigurationforshowprovinceinRegistration', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  getAllPermission() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllPermission', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  getAllAddress(custId) {
    var umodel={
      custId:custId,
      company_sy:Common.getWithExpiry("company_sy")
    }
    return this.http.post(environment.APIUrl + '/UserModule/GetShippingAddress',umodel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  insertCuUser(model) {    
    return this.http.post(environment.APIUrl + '/UserModule/InsertNewcuUser', model, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  getBusinessTypes() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllBusinesstypes', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  getCustomerMethod() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllCustomerMethods', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  getAllOrdereMethod() {
    return this.http.get(environment.APIUrl + '/UserModule/GetAllOrderMethods', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  insertnewcustomerapplication(NewCustomerViewModel){
    NewCustomerViewModel.company_sy=Common.getWithExpiry("company_sy");
    NewCustomerViewModel.company_cu=Common.getWithExpiry("company_cu");
    return this.http.post(environment.APIUrl + '/UserModule/MIInsertNewUser', NewCustomerViewModel, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  GetProfileLabel(){
    return this.http.get(environment.APIUrl + '/UserModule/GetEcommerceProfileLabel');
  }

}
